import { render } from "./Pie2Charts.vue?vue&type=template&id=3f2b9b73&scoped=true"
import script from "./Pie2Charts.vue?vue&type=script&lang=js"
export * from "./Pie2Charts.vue?vue&type=script&lang=js"

import "./Pie2Charts.vue?vue&type=style&index=0&id=3f2b9b73&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2b9b73"]])

export default __exports__